/* Parents page: volume meter sweep (into "Too loud", settles at "Comfortable") and routine line draw.
   Loaded by parents-volume and parents-routine; runs once. */
(function () {
  if (window.__dzParentsJs) return;
  window.__dzParentsJs = 1;
  var D = window.Dozzee || (window.Dozzee = {});

  function label(sec, v) {
    return v < 40 ? sec.getAttribute('data-quiet') : v < 70 ? sec.getAttribute('data-comfy') : sec.getAttribute('data-loud');
  }

  function initVolume(sec, gsap) {
    if (sec._dz) return;
    var mk = sec.querySelector('[data-vol-mark]'), lb = sec.querySelector('[data-vol-lbl]');
    if (!mk || !lb) return;
    sec._dz = 1;
    var o = { v: 8 };
    function up() {
      mk.style.insetInlineStart = o.v + '%';
      var t = label(sec, o.v);
      if (lb.textContent !== t) lb.textContent = t;
      lb.style.color = o.v >= 70 ? '#FFB3B3' : '#F4F0E6';
    }
    if (D.reduce || !gsap) { o.v = 55; up(); return; }
    up();
    gsap.timeline({ scrollTrigger: { trigger: sec, start: 'top 70%', end: 'bottom 40%', scrub: 0.6 } })
      .to(o, { v: 86, duration: 1, ease: 'power1.inOut', onUpdate: up })
      .to(o, { v: 55, duration: 0.8, ease: 'power2.out', onUpdate: up });
  }

  function initRoutine(sec, gsap) {
    if (sec._dz) return;
    var line = sec.querySelector('[data-rt-line]');
    if (!line) return;
    sec._dz = 1;
    if (D.reduce || !gsap) { line.style.transform = 'scaleY(1)'; return; }
    gsap.to(line, { scaleY: 1, ease: 'none', scrollTrigger: { trigger: sec, start: 'top 60%', end: 'bottom 70%', scrub: true } });
  }

  function init(root, gsap) {
    Array.prototype.forEach.call((root || document).querySelectorAll('[data-section-type="parents-volume"]'), function (s) { initVolume(s, gsap); });
    Array.prototype.forEach.call((root || document).querySelectorAll('[data-section-type="parents-routine"]'), function (s) { initRoutine(s, gsap); });
  }

  function start(root) {
    if (D.reduce || !D.gsap) { init(root, null); return; }
    D.gsap(function (gsap) { init(root, gsap); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { start(document); });
  else start(document);
  document.addEventListener('shopify:section:load', function (e) { start(e.target); });
})();
